const { upgradeArray } = require('../utils')

const OPERATOR_GROUPS = upgradeArray([
  'Beeline_Russia',
  'Megafon_Russia',
  'MTS_Russia',
  'Tele2_Russia',
  'Yota_Russia',
  'Motiv_Russia',
  'SMARTS_Russia',
  'Other_Russia',

  // СНГ
  'OTHER_ABKHAZIA',
  'BEELINE_ARMENIA',
  'KARABAKH_TELECOM_ARMENIA',
  'UCOM_ARMENIA',
  'VIVACELL_MTS_ARMENIA',
  'OTHER_ARMENIA',
  'BEELINE_ARMENIA',
  'KARABAKH_TELECOM_ARMENIA',
  'UCOM_ARMENIA',
  'VIVACELL_MTS_ARMENIA',
  'OTHER_ARMENIA',
  'OTHER_AZERBAIJAN',
  'AZERCELL_AZERBAIJAN',
  'BAKCELL_AZERBAIJAN',
  'NAR_MOBILE_AZERBAIJAN',
  'FONEX_AZERBAIJAN',
  'LIFE___BELARUS',
  'MTS_BELARUS',
  'VELCOM_BELARUS',
  'OTHER_BELARUS',
  'LIFE___BELARUS',
  'MTS_BELARUS',
  'VELCOM_BELARUS',
  'OTHER_BELARUS',
  'BEELINE_GEORGIA',
  'GEOCELL_GEORGIA',
  'MAGTICOM_GEORGIA',
  'OTHER_GEORGIA',
  'SILKNET_CDMA_GEORGIA',
  'TELE2__NEO_MTS__KAZAKHSTAN',
  'ALTEL__DALACOM__CDMA_KAZAKHSTAN',
  'BEELINE__KaR_Tel_LLP__KAZAKHSTAN',
  'K_CELL_KAZAKHSTAN',
  'OTHER_KAZAKHSTAN',
  'BEELINE_KG_KYRGYZSTAN',
  'FONEX_KYRGYZSTAN',
  'MEGACOM_KYRGYZSTAN',
  'NEXI__SOTEL__CDMA_KYRGYZSTAN',
  'O__KYRGYZSTAN',
  'SAPAT_MOBILE__WINLINE__CDMA_KYRGYZSTAN',
  'OTHER_KYRGYZSTAN',
  'ORANGE_MOLDOVA_MOLDOVA',
  'EVENTIS_MOBILE_MOLDOVA',
  'IDC_MOLDOVA',
  'MOLDCELL_MOLDOVA',
  'UNITE_MOLDOVA',
  'OTHER_MOLDOVA',
  'ORANGE_MOLDOVA_MOLDOVA',
  'EVENTIS_MOBILE_MOLDOVA',
  'IDC_MOLDOVA',
  'MOLDCELL_MOLDOVA',
  'UNITE_MOLDOVA',
  'OTHER_MOLDOVA',
  'BABILON_M_TAJIKISTAN',
  'BEELINE_TJ_TAJIKISTAN',
  'Indigo_Tajikistan_TAJIKISTAN',
  'M_TEKO_TAJIKISTAN',
  'MegaFon_Tajikistan__TT_Mobile__TAJIKISTAN',
  'SKYTEL_CDMA_TAJIKISTAN',
  'TCELL_TAJIKISTAN',
  'TK_MOBILE_TAJIKISTAN',
  'OTHER_TAJIKISTAN',
  'MTS_TURKMENISTAN_TURKMENISTAN',
  'TM_CELL_TURKMENISTAN',
  'OTHER_TURKMENISTAN',
  'VODAFONE__MTS__UKRAINE',
  'KYIVSTAR_UKRAINE',
  'LIFECELL_UKRAINE',
  'INTERTELECOM_CDMA_UKRAINE',
  'GOLDEN_TELECOM_UKRAINE',
  'PEOPLENET_CDMA_UKRAINE',
  'TriMob_LLC_UKRAINE',
  'OTHER_UKRAINE',
  'FENIX_UKRAINE',
  'VODAFONE__MTS__UKRAINE',
  'KYIVSTAR_UKRAINE',
  'LIFECELL_UKRAINE',
  'INTERTELECOM_CDMA_UKRAINE',
  'GOLDEN_TELECOM_UKRAINE',
  'PEOPLENET_CDMA_UKRAINE',
  'TriMob_LLC_UKRAINE',
  'OTHER_UKRAINE',
  'FENIX_UKRAINE',
  'BEELINE_UZBEKISTAN',
  'MTS_UZBEKISTAN_UZBEKISTAN',
  'UCELL_UZBEKISTAN',
  'OTHER_UZBEKISTAN',
  'PERFECTUM_UZBEKISTAN',
  'UZMOBILE_UZBEKISTAN',

  'FASTWEB_ITALY',
  'H3G_ITALIA_ITALY',
  'LYCAMOBILE_ITALY_ITALY',
  'NOVERCA_ITALY',
  'OTHER_ITALY',
  'TIM_ITALY',
  'VODAFONE_OMNITEL_N_V__ITALY',
  'WIND_TELECOMUNICAZIONI_SPA_ITALY',
  'AIRTEL_KENYA_KENYA',
  'ORANGE_KENYA',
  'OTHER_KENYA',
  'SAFARICOM_KENYA',
  'MCEL_MOZAMBIQUE',
  'MOVITEL_MOZAMBIQUE',
  'OTHER_MOZAMBIQUE',
  'VODACOM_MOZAMBIQUE_MOZAMBIQUE',

  // Дерьмовые группы для скрапетель
  'ALL_AFGHANISTAN',
  'ALL_ALBANIA',
  'ALL_ALGERIA',
  'ALL_ANDORRA',
  'ALL_ANGOLA',
  'ALL_ARGENTINA',
  'ALL_ARMENIA',
  'ALL_ARUBA',
  'ALL_AUSTRALIA',
  'ALL_AUSTRIA',
  'ALL_AZERBAIJAN',
  'ALL_BAHRAIN',
  'ALL_BANGLADESH',
  'ALL_BELARUS',
  'ALL_BELGIUM',
  'ALL_BELIZE',
  'ALL_BENIN',
  'ALL_BHUTAN',
  'ALL_BOLIVIA',
  'ALL_BOSNIA_AND_HERZEGOVINA',
  'ALL_BOTSWANA',
  'ALL_BRAZIL',
  'ALL_BRUNEI_DARUSSALAM',
  'ALL_BULGARIA',
  'ALL_BURKINA_FASO',
  'ALL_BURUNDI',
  'ALL_CAMBODIA',
  'ALL_CAMEROON',
  'ALL_CANADA',
  'ALL_CAPE_VERDE',
  'ALL_CENTRAL_AFRICAN_REPUBLIC',
  'ALL_CHAD',
  'ALL_CHILE',
  'ALL_CHINA',
  'ALL_COLOMBIA',
  'ALL_COMOROS',
  'ALL_CONGO',
  'ALL_CONGO__DEMOCRATIC_REPUBLIC_OF',
  'ALL_COOK_ISLANDS',
  'ALL_COSTA_RICA',
  'ALL_COTE_D_IVOIRE',
  'ALL_CROATIA',
  'ALL_CUBA',
  'ALL_CYPRUS',
  'ALL_CZECH_REPUBLIC',
  'ALL_DENMARK',
  'ALL_DJIBOUTI__REPUBLIC_OF',
  'ALL_ECUADOR',
  'ALL_EGYPT',
  'ALL_EL_SALVADOR',
  'ALL_EQUATORIAL_GUINEA',
  'ALL_ESTONIA',
  'ALL_ETHIOPIA',
  'ALL_FAROE_ISLANDS',
  'ALL_FIJI',
  'ALL_FINLAND',
  'ALL_FRANCE',
  'ALL_FRENCH_GUIANA',
  'ALL_FRENCH_POLYNESIA',
  'ALL_GABON',
  'ALL_GAMBIA',
  'ALL_GEORGIA',
  'ALL_GERMANY',
  'ALL_GHANA',
  'ALL_GIBRALTAR',
  'ALL_GREECE',
  'ALL_GREENLAND',
  'ALL_GUATEMALA',
  'ALL_GUINEA',
  'ALL_GUINEA_BISSAU',
  'ALL_GUYANA',
  'ALL_HONDURAS',
  'ALL_HONG_KONG',
  'ALL_HUNGARY',
  'ALL_ICELAND',
  'ALL_INDONESIA',
  'ALL_IRAN',
  'ALL_IRAQ',
  'ALL_IRELAND',
  'ALL_ISRAEL',
  'ALL_ITALY',
  'ALL_JAMAICA',
  'ALL_JAPAN',
  'ALL_JORDAN',
  'ALL_KENYA',
  'ALL_KOREA__REPUBLIC_OF',
  'ALL_KUWAIT',
  'ALL_KYRGYZSTAN',
  'ALL_LAOS',
  'ALL_LATVIA',
  'ALL_LEBANON',
  'ALL_LESOTHO',
  'ALL_LIBERIA',
  'ALL_LIBYA',
  'ALL_LIECHTENSTEIN',
  'ALL_LITHUANIA',
  'ALL_LUXEMBOURG',
  'ALL_MACAU',
  'ALL_MACEDONIA',
  'ALL_MADAGASCAR',
  'ALL_MALAWI',
  'ALL_MALAYSIA',
  'ALL_MALDIVES',
  'ALL_MALI',
  'ALL_MALTA',
  'ALL_MAURITANIA',
  'ALL_MAURITIUS',
  'ALL_MEXICO',
  'ALL_MOLDOVA',
  'ALL_MONACO',
  'ALL_MONGOLIA',
  'ALL_MONTENEGRO',
  'ALL_MOROCCO',
  'ALL_MOZAMBIQUE',
  'ALL_MYANMAR',
  'ALL_NAMIBIA',
  'ALL_NANP',
  'ALL_NEPAL',
  'ALL_NETHERLANDS',
  'ALL_NETHERLANDS_ANTILLES',
  'ALL_NEW_CALEDONIA',
  'ALL_NEW_ZEALAND',
  'ALL_NICARAGUA',
  'ALL_NIGER',
  'ALL_NIGERIA',
  'ALL_NORWAY',
  'ALL_OMAN',
  'ALL_PAKISTAN',
  'ALL_PANAMA',
  'ALL_PAPUA_NEW_GUINEA',
  'ALL_PARAGUAY',
  'ALL_PERU',
  'ALL_POLAND',
  'ALL_PORTUGAL',
  'ALL_QATAR',
  'ALL_REUNION',
  'ALL_ROMANIA',
  'ALL_RWANDA__REPUBLIC_OF',
  'ALL_SAUDI_ARABIA',
  'ALL_SENEGAL',
  'ALL_SERBIA',
  'ALL_SEYCHELLES',
  'ALL_SIERRA_LEONE',
  'ALL_SINGAPORE',
  'ALL_SLOVAKIA',
  'ALL_SLOVENIA',
  'ALL_SOLOMON_ISLANDS',
  'ALL_SOMALIA',
  'ALL_SOUTH_AFRICA',
  'ALL_SOUTH_SUDAN',
  'ALL_SPAIN',
  'ALL_SRI_LANKA',
  'ALL_SUDAN',
  'ALL_SURINAME',
  'ALL_SWAZILAND',
  'ALL_SWEDEN',
  'ALL_SWITZERLAND',
  'ALL_SYRIA',
  'ALL_TAIWAN',
  'ALL_TAJIKISTAN',
  'ALL_TANZANIA',
  'ALL_THAILAND',
  'ALL_TOGO',
  'ALL_TONGA',
  'ALL_TUNISIA',
  'ALL_TURKEY',
  'ALL_TURKMENISTAN',
  'ALL_UGANDA',
  'ALL_UKRAINE',
  'ALL_UNITED_ARAB_EMIRATES',
  'ALL_UNITED_KINGDOM',
  'ALL_UNITED_STATES',
  'ALL_URUGUAY',
  'ALL_UZBEKISTAN',
  'ALL_VANUATU',
  'ALL_VENEZUELA',
  'ALL_VIETNAM',
  'ALL_YEMEN',
  'ALL_ZAMBIA',
  'ALL_ZIMBABWE',
  'ALL_INDIA'
].sort())

module.exports = {
  OPERATOR_GROUPS
}
